<template>
  <div id="app">
    <keep-alive>
      <router-view v-if='$route.meta.keepAlive' />
    </keep-alive>
     <router-view v-if='!$route.meta.keepAlive' />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>


<style>
.flex-row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.flex-row-space-around {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.flex-colnum-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue